//= Functions & Modules
// Own
import { DialogsSystem } from '../components/DialogsSystem';

export function getDialogsSystem(): DialogsSystem {
    return window.g_dialogsSystem;
}
